export type DbOrderLine = {
  name: string;
  quantity: number;
  price: number;
  product: number;
};

export type OrderLine = {
  name: string;
  quantity: number;
  price: number;
  product?: Product;
  orderLineId: string;
};

// Kundeoplysninger gemt direkte på ordren (snapshot ved oprettelse, frit redigerbar
// derefter). Aldrig genudledt fra telefonbogen (customers) — se OrderCustomer/customerId.
export type OrderCustomer = {
  name: string;
  phone: string;
  address?: string;
  company?: string;
  companyCvr?: string;
};

export type Order = {
  id: string;
  status: string;
  customer: OrderCustomer;
  /** Valgfri, ren opslags-reference til telefonbogs-kunden ("find alle ordrer for denne
   *  kunde"). Bruges aldrig til at genudlede `customer` ovenfor. */
  customerId?: number | null;
  startDate: number;
  endDate: number;
  orderLines: OrderLine[];
  deliveryPrice: number;
  totalPrice: number;
  hasDelivery: boolean;
  paymentDate: number | null;
  note: string | null;
  hasMoms: boolean;
  revolutOrderId?: string;
};

export type NewOrder = {
  id: string;
  status: string;
  customerName: string;
  customerPhone: string;
  customerAddress?: string | null;
  customerCompany?: string | null;
  customerCompanyCvr?: string | null;
  customerId?: number | null;
  startDate: number;
  endDate: number;
  deliveryPrice: number | null;
  totalPrice: number;
  hasDelivery: boolean;
  paymentDate: number | null;
  note: string | null;
  hasMoms: boolean;
};

export type NewCustomer = {
  id?: number;
  name: string;
  phone: string;
  address?: string;
  company?: string;
  companyCvr?: string;
  primary?: boolean;
};
export type Customer = {
  id: number;
  name: string;
  phone: string;
  address?: string;
  company?: string;
  companyCvr?: string;
  primary?: boolean;
};

export type Product = {
  id: number;
  name: string;
  description: string;
  price: number;
  imageUrl: string;
  available: number;
  category: PRODUCT_CATEGORY;
  washPrice: number | null;
  order: number;
  isPublic: boolean;
  replacementProduct: Product | null;
};

export type NewProduct = {
  id?: number;
  name: string;
  description: string;
  price: number;
  imageUrl: string;
  available: number;
  category: PRODUCT_CATEGORY;
  washPrice: number | null;
  order: number;
  isPublic: boolean;
  replacementProduct: number | null;
};

export type NewExpense = {
  id?: string;
  name: string;
  date: number;
  quantity: number;
  price: number;
  expenseUrl: string | null;
  note: string;
  hasMoms: boolean;
};

export type Expense = {
  id: string;
  name: string;
  date: number;
  quantity: number;
  price: number;
  expenseUrl: string | null;
  note: string;
  hasMoms: boolean;
};

export const PRODUCT_CATEGORIES = [
  'borde',
  'stole',
  'telte',
  'service',
  'erstatning',
  'tekstil',
  'andet',
] as const;

export type PRODUCT_CATEGORY = (typeof PRODUCT_CATEGORIES)[number];

export enum STATUS {
  KLADDE = 'KLADDE',
  TILBUD = 'TILBUD',
  BEKRÆFTET = 'BEKRÆFTET',
  UDE = 'UDE',
  BETALING = 'BETALING',
  AFSLUTTET = 'AFSLUTTET',
}

export type User = {
  id: number;
  name: string;
};
